import { useEffect } from 'react';
import { CircleCheck, CircleX, TriangleAlert, X } from 'lucide-react';

import type { AdminToastState } from './adminToastTypes';
import { announce } from '../ui/live-announcer';

export function AdminToast({ onClose, toast }: { toast: AdminToastState; onClose: () => void }) {
    useEffect(() => {
        if (toast.show && toast.message) {
            announce(toast.message, { assertive: toast.type === 'error' });
        }
    }, [toast.show, toast.message, toast.type]);

    if (!toast.show) return null;

    return (
        <div className="fixed bottom-4 left-4 z-[60]">
            <div
                className={`flex max-w-sm items-center rounded-lg border px-4 py-3 shadow-lg ${
                    toast.type === 'success'
                        ? 'border-green-200 bg-green-50 text-green-800'
                        : toast.type === 'warning'
                          ? 'border-amber-200 bg-amber-50 text-amber-900'
                          : 'border-red-200 bg-red-50 text-red-800'
                }`}
            >
                {toast.type === 'success' ? (
                    <CircleCheck className="mr-2 size-5 shrink-0 text-green-600" aria-hidden />
                ) : toast.type === 'warning' ? (
                    <TriangleAlert className="mr-2 size-5 shrink-0 text-amber-600" aria-hidden />
                ) : (
                    <CircleX className="mr-2 size-5 shrink-0 text-red-600" aria-hidden />
                )}
                <span className="text-sm font-medium">{toast.message}</span>
                <button
                    type="button"
                    onClick={onClose}
                    className="-my-1 -mr-1 ml-3 flex size-7 shrink-0 items-center justify-center rounded-md text-neutral-500 hover:bg-black/5 hover:text-neutral-800"
                    aria-label="Dismiss notification"
                >
                    <X className="size-4" aria-hidden />
                </button>
            </div>
        </div>
    );
}
